<template>
  <div class="mail-notify-container">
    <!-- 顶部工具栏 -->
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-refresh" @click="loadNotifyList">刷新配置</el-button>
      <el-button type="primary" icon="el-icon-refresh" @click="addNewMailNotify">新增</el-button>
    </div>

    <!-- 通知类型主表格 -->
    <el-table
      :data="notifyList"
      border
      stripe
      style="width: 100%;margin-top:10px"
    >
      <el-table-column label="通知标识" prop="notify_code" width="160" />
      <el-table-column label="通知名称" prop="notify_name" width="200" />
      <el-table-column label="启用状态" width="120">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enable_switch"
            :active-value="1"
            :inactive-value="0"
            @change="changeSwitch(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" />
      <el-table-column label="创建时间" prop="created_at" width="180" />
      <el-table-column label="操作" width="280" align="center">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-message" @click="openEmailDialog(scope.row)">配置收件邮箱</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 收件邮箱弹窗 -->
    <el-dialog title="收件邮箱管理" :visible.sync="emailDialogVisible" width="60%" @close="resetEmailForm">
      <div style="margin-bottom:10px">
        <el-button type="primary" icon="el-icon-plus" @click="addEmptyEmailRow">新增邮箱</el-button>
      </div>
      <el-table :data="emailTable" border stripe>
        <el-table-column label="收件邮箱地址" prop="receive_email">
          <template slot-scope="scope">
            <el-input v-model="scope.row.receive_email" placeholder="请输入邮箱地址" />
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sort" width="100">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.sort" :min="0" size="small" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.id" type="text" icon="el-icon-delete" @click="delSingleEmail(scope.row.id)" danger>删除</el-button>
            <el-button v-else type="text" icon="el-icon-add" @click="addSingleEmail(scope.row)" danger>新增</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 邮件日志弹窗 -->
    <el-dialog title="邮件发送日志" :visible.sync="logDialogVisible" width="80%">
      <el-table
        :data="logList"
        border
        stripe
        :loading="logLoading"
      >
        <el-table-column label="收件邮箱" prop="receive_email" width="200" />
        <el-table-column label="邮件标题" prop="mail_title" />
        <el-table-column label="发送状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.send_status===1?'success':'danger'">
              {{scope.row.send_status===1?'成功':'失败'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="错误信息" prop="error_msg" />
        <el-table-column label="发送时间" prop="created_at" width="180" />
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleLogSizeChange"
        @current-change="handleLogPageChange"
        :current-page="logPage"
        :page-sizes="[10, 15, 20]"
        :page-size="logPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="logTotal"
        style="margin-top:10px;text-align:right"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mailnotifylist,mailnotifyswitch,mailnotifyreceivers,mailnotifydelreveiver,mailnotifyaddreveiver } from '../api/api';
export default {
  name: "SysMailNotify",
  data() {
    return {
      // 通知主列表
      notifyList: [],
      // 邮箱弹窗
      emailDialogVisible: false,
      currentNotifyCode: "",
      emailTable: [],
      // 日志弹窗
      logDialogVisible: false,
      logLoading: false,
      logList: [],
      logPage: 1,
      logPageSize: 15,
      logTotal: 0
    };
  },
  mounted() {
    this.loadNotifyList();
  },
  methods: {

    addNewMailNotify(){
        
    },
    // 加载通知类型列表
    async loadNotifyList() {
    
       try {
            const res = await mailnotifylist();
            this.notifyList = res;

            console.log("loadNotifyList",res)

        } catch (error) {
            this.$message.error(error)
        }
    
    },
    // 切换开关状态
    async changeSwitch(row) {

        try {
           const res = await mailnotifyswitch({code:row.notify_code,enable:row.enable_switch})
           console.log("changeSwitch:",res)
            this.$message.success("开关修改成功");
        } catch (error) {
             this.$message.error(error);
            // 失败回显原始值
            this.loadNotifyList();
        }
      
    },
    // 打开邮箱配置弹窗
    async openEmailDialog(row) {
      this.currentNotifyCode = row.notify_code;
      this.emailDialogVisible = true;
      try {

        const res = await mailnotifyreceivers(this.currentNotifyCode)

        this.emailTable = res;
        

      } catch (error) {
        
      }
    },
    // 新增空邮箱行
    addEmptyEmailRow() {
        this.emailTable.push({
            _tempId: Date.now(), // ✅ 增加临时唯一ID，用来定位行
            notify_code: this.currentNotifyCode,
            receive_email: "",
            sort: this.emailTable.length + 1,
            id: null // 后端持久化之前id为空
        });
    },

   async addSingleEmail(row){
    try {
        const res = await mailnotifyaddreveiver({code:this.currentNotifyCode,mail:row.receive_email})
        const new_id = res.id
        // ✅ 通过临时唯一key匹配，不再依靠邮箱文本
        const origin_row = this.emailTable.find(emdata=>emdata._tempId === row._tempId)

        if(origin_row && new_id){
            // 关键：不能直接 origin_row.id = new_id
            // 构造新对象替换数组元素，Vue2监听数组引用变更
             const idx = this.emailTable.findIndex(emdata=>emdata._tempId === row._tempId)
             this.emailTable.splice(idx, 1, { ...origin_row, id: new_id })
        }
     } catch (error) {
        this.$message.error(error)
     }
    },
    // 删除单行邮箱
    async delSingleEmail(id) {

        try {
            const res = await mailnotifydelreveiver(id)
            this.emailTable = this.emailTable.filter(emdata=>emdata.id != id)
            this.$forceUpdate()
        } catch (error) {
            this.$message.error(error)
        }
        
        
    //   this.emailTable.splice(index, 1);
    },
    // 批量保存全部邮箱（覆盖式）
    async saveAllEmail() {
      // 过滤空邮箱
      const emailArr = this.emailTable
        .filter(item => item.receive_email.trim() !== "")
        .map(item => item.receive_email.trim());
      const res = await this.$api.post("/admin/notify/mail/receiver/save", {
        notify_code: this.currentNotifyCode,
        email_arr: emailArr
      });
      if (res.code === 200) {
        this.$message.success("邮箱配置保存成功");
        this.emailDialogVisible = false;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 关闭弹窗重置数据
    resetEmailForm() {
      this.currentNotifyCode = "";
      this.emailTable = [];
    },
    // 打开日志弹窗
    openLogDialog(row) {
      this.logDialogVisible = true;
      this.logPage = 1;
      this.loadLogData(row.notify_code);
    },
    // 加载日志数据
    async loadLogData(code) {
    //   this.logLoading = true;
    //   const res = await this.$api.get("/admin/notify/mail/log", {
    //     params: {
    //       notify_code: code,
    //       page: this.logPage,
    //       page_size: this.logPageSize
    //     }
    //   });
    //   this.logLoading = false;
    //   if (res.code === 200) {
    //     this.logList = res.data.list;
    //     this.logTotal = res.data.total;
    //   }
    },
    handleLogPageChange(page) {
      this.logPage = page;
      this.loadLogData(this.currentNotifyCode);
    },
    handleLogSizeChange(size) {
      this.logPageSize = size;
      this.logPage = 1;
      this.loadLogData(this.currentNotifyCode);
    }
  }
};
</script>

<style scoped>
.mail-notify-container {
  padding: 15px;
}
.toolbar {
  display: flex;
  justify-content: flex-start;
}
</style>